import gql from 'graphql-tag';
import { DEAL_SHEET_CONFIGURATION_FRAGMENT } from './configurationFragment';

export const UPDATE_DEAL_SHEET_CONFIGURATION = gql`
  mutation UpdateDealSheetConfig($input: UpdateDealSheetConfigurationInput!) {
    dealSheet {
      result: updateConfiguration(input: $input) {
        error
        success
        entity {
          ...DealSheetConfig
        }
      }
    }
  }
  ${DEAL_SHEET_CONFIGURATION_FRAGMENT}
`;
